module.exports = __webpack_public_path__ + "static/media/13.8338c3df.JPG";